import { render, staticRenderFns } from "./CriterionOptionSelection.vue?vue&type=template&id=79248dbd&scoped=true&"
import script from "./CriterionOptionSelection.vue?vue&type=script&lang=js&"
export * from "./CriterionOptionSelection.vue?vue&type=script&lang=js&"
import style0 from "./CriterionOptionSelection.vue?vue&type=style&index=0&id=79248dbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79248dbd",
  null
  
)

export default component.exports